var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleicon = function SvgGoogleicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M30.501 16.31c0-1.15-.095-1.99-.301-2.861H16.787v5.195h7.873c-.159 1.291-1.016 3.236-2.92 4.542l-.027.174 4.24 3.22.294.029c2.699-2.443 4.254-6.036 4.254-10.298z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16.786 30c3.857 0 7.095-1.244 9.46-3.391l-4.507-3.423c-1.207.825-2.826 1.4-4.953 1.4A8.584 8.584 0 0 1 8.66 18.77l-.167.014-4.41 3.344-.058.157C6.374 26.858 11.2 30 16.786 30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M8.66 18.769a8.463 8.463 0 0 1-.476-2.77c0-.964.175-1.897.46-2.768l-.008-.185-4.465-3.399-.146.068A13.785 13.785 0 0 0 2.501 16c0 2.256.556 4.387 1.524 6.284L8.66 18.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M16.786 7.413c2.683 0 4.492 1.136 5.524 2.085l4.032-3.858C23.866 3.384 20.644 2 16.786 2 11.2 2 6.374 5.142 4.024 9.715l4.62 3.516c1.158-3.375 4.365-5.818 8.142-5.818z"
  })));
};
export default SvgGoogleicon;